export default "__VITE_ASSET__DuxSKkPo__"